import React from 'react';
import { Box } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { useFeedback } from '../../state/hooks/useFeedback';
import styles from './FeedbackOverlay.module.css';

/**
 * FeedbackOverlay component - displays a feedback message overlay
 * that appears when actions are performed (e.g., adding to favourites).
 * Uses the FeedbackContext to determine visibility and message.
 */
const FeedbackOverlay: React.FC = () => {
  const { isVisible, message } = useFeedback();

  if (!isVisible) {
    return null;
  }

  return (
    <Box className={styles.container}>
      <Box className={styles.overlay}>
        <CheckIcon className={styles.icon} />
        <span className={styles.text}>{message}</span>
      </Box>
    </Box>
  );
};

export default FeedbackOverlay;
